import Mutations from '../../odata/mutations';

export default { ...new Mutations('brandingCode'), ...new Mutations('brandingCodes') };
